import React, {useState} from 'react';
import InputTextField from "../components/InputTextfield";
import './/StylePages/Contact.css';

const Contact=()=> {

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }

    const buildMailTo = () => {
        const subject = encodeURIComponent(formData.lastName);
        const body = encodeURIComponent(
            `Name: ${formData.firstName}
                         Email: ${formData.email}
                         Message:${formData.message}`
        );
        return `mailto:siarradjabi@gmail.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="ContactContainer">
            <div className="backgroundImage"></div>
            <h1 className="Header1" style={{color:"white"}}>
                Contact me
            </h1>
                <ul className="createAccountList" style={{
                    listStyleType: "none",
                    textAlign: "center",
                    marginTop: "5%",
                    paddingRight: "20%",
                    paddingLeft: "20%",
                    paddingBottom: "5%",
                }}>
                    <li style={{position: "relative"}}>
                        <InputTextField
                            name="firstName"
                            onChange={handleChange}
                            type="text"
                            label="Name"
                        />
                    </li>
                    <li style={{position: "relative"}}>
                        <InputTextField
                            name="lastName"
                            onChange={handleChange}
                            type="text"
                            label="Subject"
                        />
                    </li>
                    <li style={{position: "relative"}}>
                        <InputTextField
                            name="email"
                            onChange={handleChange}
                            type="email"
                            label="Email Address"
                        />
                    </li>
                    <li style={{position: "relative",marginTop:"10%"}}>
                        <textarea
                            placeholder="Write something"
                            className="MessageTextArea"
                            maxLength="2000"
                            name="message"
                            onChange={handleChange}
                            type="text"
                            label="Message"/>
                    </li>
                    <li style={{marginTop: "10%"}}>
                        <a
                            href={buildMailTo()}
                            className="submit_button"
                            style={{ textDecoration: "none" }}
                        >
                            Send
                        </a>
                    </li>
                </ul>
        </div>
    )
}


export default Contact;